/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageMotou } from "../../funcs/imagePostImageMotou.js";
import { PostImageMotouRequest$zodSchema } from "../../models/postimagemotouop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageMotouRequest$zodSchema,
};

export const tool$imagePostImageMotou: ToolDefinition<typeof args> = {
  name: "image-post-image-motou",
  description: `生成摸摸头GIF

除了使用QQ头像，你还可以通过上传自己的图片或提供图片URL来制作独一无二的摸摸头GIF。

## 功能概述
此接口通过POST方法，支持两种方式生成GIF：
1.  **图片URL**：在表单中提供 \`image_url\` 字段。
2.  **上传图片**：在表单中上传 \`file\` 文件。

## 使用须知
- **响应格式**：接口成功时直接返回 \`image/gif\` 格式的二进制数据。
- **参数优先级**：如果同时提供了 \`image_url\` 和上传的 \`file\` 文件，系统将 **优先使用 \`image_url\`**。
- **背景颜色**：同样支持 \`bg_color\` 表单字段来控制GIF背景。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageMotou(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
